<!-- =========================================================================================
    File Name: UserProfile.vue
    Description: user profile sidebar
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="parentx-demo-2">
		<vs-sidebar
			parent="#chat-app"
			:position-right="!isLoggedInUser"
			:hidden-background="false"
			v-model="activeLocal"
			id="chat-profile-sidebar"
			class="items-no-padding"
		>
			<div class="header-sidebar relative flex flex-col p-0" slot="header">
				<feather-icon
					icon="XIcon"
					svgClasses="m-2 cursor-pointer absolute top-0 right-0"
					@click="$emit('closeProfileSidebar', false)"
				></feather-icon>

				<div class="relative inline-flex mx-auto mb-5 mt-6">
					<vs-avatar class="m-0 border-white border-2 border-solid shadow-md" :src="avatar" size="70px" />
					<div
						class="h-5 w-5 border-white border-2 border-solid rounded-full absolute right-0 bottom-0"
						:class="'bg-' + statusColor"
					></div>
				</div>
				<h4 class="mr-2 self-center">{{ resource ? resource.name + " " + resource.lastname : "" }}</h4>
				<h5 class="mr-2 self-center">{{ resource ? resource.username : "" }}</h5>
				<h6 class="mr-2 self-center">{{ resource ? resource.email : "" }}</h6>
			</div>
			<component :is="scrollbarTag" class="scroll-area" :settings="settings" :key="$vs.rtl">
				<div class="p-8">
					<div class="userProfile__status" v-if="isLoggedInUser">
						<h6 class="mb-4">{{ $t("Options") }}</h6>
						<ul>
							<li class="mb-2">
								<vs-button
									@click="popupGroupInfo = true"
									icon-pack="feather"
									color="danger"
									type="border"
									icon="icon-users"
									class="w-full mt-1"
									>{{ $t("CreateGroup") }}
								</vs-button>
							</li>
						</ul>
					</div>
				</div>
			</component>
		</vs-sidebar>

		<vs-prompt
			:title="$t('CreateGroup')"
			class="export-options"
			:accept-text="$t('Crud.Create')"
			:cancel-text="$t('Cancel')"
			:is-valid="groupSelectedMembers.length > 0 && groupName !== ''"
			:active.sync="popupGroupInfo"
			@cancel="closePopUp"
			@accept="createChatGroup"
			@close="closePopUp"
		>
			<label class="vs-input--label">{{ $t("Name") }}</label>
			<vs-input v-model="groupName" class="w-full" />
			<label class="vs-input--label">{{ $t("Chat.Members") }}</label>
			<treeselect
				value-consists-of="LEAF_PRIORITY"
				:default-expand-level="1"
				:placeholder="$t('Username')"
				:clearable="false"
				:multiple="true"
				:options="contacts"
				v-model="groupSelectedMembers"
				:max-height="300"
				:noResultsText="$t('Chat.NoContactFound')"
			/>
		</vs-prompt>
	</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {downloadFileFromFirebase} from "@/helpers/firebaseDB.js";
import moduleResource from "@/store/resource/moduleResource.js";

export default {
	props: {
		userId: {
			type: Number,
			required: true,
		},
		active: {
			type: Boolean,
			required: true,
		},
		isLoggedInUser: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			popupGroupInfo: false,
			groupName: "",
			groupSelectedMembers: [],
			avatar: null,
			resource: null,
		};
	},
	watch: {
		activeLocal(val) {
			this.avatar = null;
			if (val && this.userId) {
				this.resource = "";
				this.getResourceInfo(this.userId);
			} else {
				const userInfo = JSON.parse(localStorage.getItem("userInfo"));
				const userId = userInfo.datarutas_id;
				this.getResourceInfo(userId);
			}
		},
	},
	computed: {
		chatUser() {
			return this.$store.state.AppActiveUser;
		},
		userFcmToken() {
			return this.$store.getters["chat/contactFcmToken"](this.userId);
		},
		activeLocal: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("closeProfileSidebar", value);
			},
		},
		status: {
			get() {
				return this.chatUser.status;
			},
			set(value) {
				this.$store.dispatch("updateUserInfo", {status: value});
			},
		},
		statusColor() {
			if (this.userFcmToken && this.userFcmToken.is_online) {
				return "success";
			} else {
				return "grey";
			}
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
		contacts() {
			const contacts = this.$store.getters["chat/contacts"];
			let usersContacts = contacts.map((resource) => {
				return {id: resource.id, label: resource.username};
			});
			return usersContacts;
		},
	},
	methods: {
		closePopUp() {},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		async createChatGroup() {
			this.openLoading();
			try {
				const chatKey = await this.$store.dispatch("chat/startGroupChatRoom", {
					receiver: this.groupSelectedMembers,
					text: `${this.$t("Chat.GroupAdded")} ${this.groupName}`,
					name: this.groupName,
				});
				this.groupName = "";
				this.groupSelectedMembers = [];
				this.closeLoading();
			} catch (error) {
				this.closeLoading();
			}
		},
		getResourceInfo(userId) {
			const dataFilter = {
				ids: [userId],
			};
			this.$store
				.dispatch("moduleResource/fetchResourceFilterById", dataFilter)
				.then((res) => {
					this.resource = res.data.records[0];
					this.getResourcePhoto(this.resource.img_url);
				})
				.catch((err) => {
					console.error(err);
				});
		},
		getResourcePhoto(img_url) {
			const url = img_url;
			if (!url) {
				return;
			}
			downloadFileFromFirebase(url).then((res) => {
				this.avatar = res;
			});
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
	},
	components: {
		VuePerfectScrollbar,
		Treeselect,
	},
};
</script>
